/* eslint-disable camelcase, consistent-return, eqeqeq, func-names, max-len, no-plusplus, no-shadow, one-var */
import 'history';
import 'imagesloaded';
import 'jquery-placeholder';
import 'netc-tabs';
import 'netc-typeahead';
import layout from 'netc-layout';

Sys.WebForms.PageRequestManager.getInstance().add_endRequest(RunAjaxJs);

let loadedCount = 0;
const errorCount = 0;
let $productItems = $('.productArea .productItem');

function RunAjaxJs() {
  $productItems = $('.productArea .productItem');
  RunDocumentReadyFunctions();

  ImageLoaded();
  LoadAjaxImages();
}
function regreplace() {
  const currentPage = $('a.CMSBreadCrumbsCurrentItem').attr('href');
  if (currentPage === '/header/about/') {
    const reg = new RegExp('\u00ae', 'g');
    const newBody = $('body').html().replace(reg, '<sup>&reg</sup>');
    $('body').html(newBody);
  }
}
$(document).ready(() => {
  regreplace();
  RunDocumentReadyFunctions();
});

// resize productsBox
function productsBox() {
  $productItems.each(function () {
    $(this).height('auto');
  });

  // These are the boxes we need to resize
  const boxes = $productItems;
  let maxHeight = 0;

  // Determine the tallest box
  boxes.each(function () {
    const selfHeight = $(this).outerHeight();
    if (selfHeight > maxHeight) {
      maxHeight = selfHeight;
    }
  });

  if (maxHeight > 0) {
    // Set the height of each of the boxes
    boxes.each(function () {
      const self = $(this);
      self.height(maxHeight - 140);
    });
  }
}

function ImageLoaded() {
  loadedCount++;
  checkAllLoaded();
}

// call back method - checks all images have been loaded before executing.
function checkAllLoaded() {
  const imgList = $('.productArea .loadedInImage');
  const imageCount = imgList.length;
  if (loadedCount + errorCount === imageCount) {
    productsBox();
    setTimeout(() => {
      productsBox();
    }, 1000);
  }
}

function RunDocumentReadyFunctions() {
  LoadAjaxImages();

  // Code to dynamically resize iFrame on product registration page
  let ew_lastIframeSize = '';
  function ew_updateIframeSize(event) {
    if (event.origin !== 'http://webservice.ttigroup.eu') {
      return;
    }
    if (event.data != ew_lastIframeSize) {
      const frame = document.getElementById('ew_registration_iframe');
      if (frame) {
        document.getElementById('ew_registration_iframe').style.height = `${event.data}px`;
        ew_lastIframeSize = event.data;
      }
    }
  }
  window.addEventListener('message', ew_updateIframeSize, false);

  // Automatically play a video if necessary
  if (window.location.href.toUpperCase().indexOf('?PLAYVIDEO') > -1) {
    setTimeout(() => {
      const playVideoAutomatically = function playVideoAutomatically() {
        // Grab the video index from the queryString
        function getQueryVariable(variable) {
          const query = window.location.search.substring(1);
          const vars = query.split('&');
          for (let i = 0; i < vars.length; i++) {
            const pair = vars[i].split('=');
            if (pair[0] == variable) {
              return pair[1];
            }
          }
          return (false);
        }
        const playVideoIndex = parseInt(getQueryVariable('playVideo'), 0);

        // Grab the index and if it has been set
        // then try to launch the video automatically
        if (playVideoIndex > 0) {
          const video = $(`[data-youtube=${playVideoIndex - 1}]`).first();
          // Find the video and simulate a click
          video.click();
          // $(video)[playVideoIndex - 1].click();
        }
      };
      playVideoAutomatically();
    }, 1500);
  }

  $('.review-form .file-upload>div>div>div').load(() => {
    $('.review-form .file-upload>div>div>div').width($('.file-upload').outerWidth() - $('.file-upload .btn-browse').outerWidth() - 10);
  });

  $('.uploadImage').click(() => {
    $('.imageUpload').click();
  });

  $('.allowMultiple input[type="file"]').attr('name', 'file[]').attr('multiple', '');

  $('.CalendarTextBox').click(function () {
    $(this).next('.btn-icon')[0].click();
    return false;
  });

  $('.faqItem .faqTop').click(function () {
    $(this).parent('.faqItem').toggleClass('activeFaq');
    $(this).next('.faqMain').slideToggle();
  });

  $('label.hidden, .NewsletterSubscription .control-label').each(function () {
    const $this = $(this);
    const name = $this.attr('for');
    $(`#${name}`).attr('placeholder', $this.html().replace(':', '').replace('<span class="required-mark">*</span>', ''));
  });

  // sign up nav
  $('.mailIcon').click(() => {
    $('.signupPop').toggle();
    return false;
  });
  $('.exit').click(() => {
    $('.signupPop').toggle();
    return false;
  });
  // add class to tab
  $('.filters .tabs li .projectCentreImg').parent('li').addClass('projCenterTab');

  let switched = false;
  const updateTables = function () {
    if (($(window).width() < 767) && !switched) {
      switched = true;
      $('table.responsive').each((i, element) => {
        splitTable($(element));
      });
      return true;
    } if (switched && ($(window).width() > 767)) {
      switched = false;
      $('table.responsive').each((i, element) => {
        unsplitTable($(element));
      });
    }
  };
  $(window).load(updateTables);
  $(window).on('redraw', () => {
    switched = false;
    updateTables();
  }); // An event to listen for
  $(window).on('resize', updateTables);

  function splitTable(original) {
    original.wrap("<div class='table-wrapper' />");

    const copy = original.clone();
    copy.find('td:not(:first-child), th:not(:first-child)').css('display', 'none');
    copy.removeClass('responsive');

    original.closest('.table-wrapper').append(copy);
    copy.wrap("<div class='pinned' />");
    original.wrap("<div class='scrollable' />");

    setCellHeights(original, copy);

    const $stockTable = $('.stock .scrollable');
    const $techTable = $('.tech .scrollable');

    if ($stockTable.length && $techTable.length) {
      $stockTable.scroll(() => {
        $techTable.scrollTop($stockTable.scrollTop());
        $techTable.scrollLeft($stockTable.scrollLeft());
      });

      $techTable.scroll(() => {
        $stockTable.scrollTop($techTable.scrollTop());
        $stockTable.scrollLeft($techTable.scrollLeft());
      });
    }
  }

  function unsplitTable(original) {
    original.closest('.table-wrapper').find('.pinned').remove();
    original.unwrap();
    original.unwrap();
  }

  function setCellHeights(original, copy) {
    const tr = original.find('tr'),
      tr_copy = copy.find('tr'),
      heights = [];

    tr.each(function (index) {
      const self = $(this),
        tx = self.find('th, td');

      tx.each(function () {
        const height = $(this).height();
        heights[index] = heights[index] || 0;
        if (height > heights[index]) {
          heights[index] = height;
        }
      },
      );
    });

    tr_copy.each(function (index) {
      $(this).height(heights[index]);
    });
  }

  // Fix inputs with placeholders
  $('input[placeholder], textarea[placeholder]').placeholder();

  // resize newsDimensions
  const resizeCategoryBoxes = function () {
    // These are the boxes we need to resize
    const boxes = $('.newsItem .newsDimension');
    let maxHeight = 0;

    // Determine the tallest box
    boxes.each(function () {
      const self = $(this);
      if (self.height() > maxHeight) {
        maxHeight = self.height();
      }
    });

    // Set the height of each of the boxes
    boxes.each(function () {
      const self = $(this);
      self.height(maxHeight);
    });
  };
  resizeCategoryBoxes();

  // Also resize boxes on window resize
  $(window).resize(() => {
    $('.newsItem .newsDimension').each(function () {
      $(this).height('auto');
    });
    resizeCategoryBoxes();
  });

  // resize VidDimensions
  const vidDimension = function () {
    // These are the boxes we need to resize
    const boxes = $('.newsItem .vidDimension');
    let maxHeight = 0;

    // Determine the tallest box
    boxes.each(function () {
      const self = $(this);
      if (self.height() > maxHeight) {
        maxHeight = self.height();
      }
    });

    // Set the height of each of the boxes
    boxes.each(function () {
      const self = $(this);
      self.height(maxHeight);
    });
  };
  vidDimension();

  // Also resize boxes on window resize
  $(window).resize(() => {
    $('.newsItem .vidDimension').each(function () {
      $(this).height('auto');
    });
    vidDimension();
  });

  // Project centre
  $('#live-social-feed').hide();

  $('#ryobi-projects-button').click(function () {
    $(this).addClass('standardGreenBtn').removeClass('standardGreyBtn');
    $('#live-social-feed-button').addClass('standardGreyBtn').removeClass('standardGreenBtn');
    $('#live-social-feed').hide();
    $('#ryobi-projects').fadeIn(500);
  });

  $('#live-social-feed-button').click(function () {
    $(this).addClass('standardGreenBtn').removeClass('standardGreyBtn');
    $('#ryobi-projects-button').addClass('standardGreyBtn').removeClass('standardGreenBtn');
    $('#ryobi-projects').hide();
    $('#live-social-feed').fadeIn(500);
  });

  $(window).load(() => {
    // Resize project centre items of listings page
    let projResultItemHeight = 250;
    $('.projResults .projItem').each(function () {
      $(this).attr('style', '');
      if ($(this).height() > projResultItemHeight) {
        projResultItemHeight = $(this).height();
      }
    });

    $('.projResults .projItem').each(function () {
      $(this).height(projResultItemHeight);
      if ($(this).width() < 235) {
        $('.projResults .projItem .moderationButton').hide();
      }
    });
  });

  // Sign up page
  // Hide block row if no content
  $('.winWrap .productSignUp .align-table').each(function () {
    if ($(this).html().trim().length === 0) {
      $(this).parent().parent().hide();
    }
  });
  $('.winWrap .textSignUp').each(function () {
    if ($(this).html().trim().length === 0) {
      $(this).parent().hide();
    }
  });

  // add arrows to links
  $('.winWrap .greenSquare, .winWrap .greenSquareLeft').each(function () {
    $(this).append('<span class="buttonArrow"></span>');
  });

  const isInIframe = (window.location != window.parent.location); // check for CMS Desk
  // hide terms and toggle on click
  $('#terms-conditions').css('height', $('#terms-conditions').show().height());

  if (!isInIframe) {
    $('.winWrap #terms-conditions').hide();
    $('.winWrap #view-terms-conditions').click(() => {
      if ($('#terms-conditions').is(':hidden')) {
        $('#terms-conditions').show();
        $('#view-terms-conditions span').addClass('open');
      } else {
        $('#terms-conditions').slideUp(300);
        $('#view-terms-conditions span').removeClass('open');
      }

      $('html, body').animate({
        scrollTop: $('#terms-conditions').offset().top,
      }, 500);

      return false;
    });

    $('.winWrap #view-terms-conditions-agree').click(() => {
      if ($('#terms-conditions').length > 0) {
        if ($('#terms-conditions').is(':hidden')) {
          $('#terms-conditions').show();
          $('#view-terms-conditions span').addClass('open');
        }

        $('html, body').animate({
          scrollTop: $('#terms-conditions').offset().top,
        }, 500);
      }
      return false;
    });

    $('.winWrap .productSignUp iframe').each(function () {
      $(this).attr('width', '100%');
      $(this).attr('height', '100%');
      const currentSrc = $(this).attr('src');
      $(this).attr('src', `${currentSrc}&amp;showinfo=0`);
    });
  }

  // New contact form
  if ($('.registrationText div').length > 0) {
    $('.registrationText').hide();
    $('.registrationText div').html($('.product-registration-hidden').html());
  }

  if ($('select.contact-type').length > 0) {
    switch ($('select.contact-type').val().substring(0, 2)) {
      case 'PR':
        $('.registrationText').show();
        break;
      case 'SP':
        if ($('.spare-parts').length > 0) {
          $('.contact-warranty-form').hide();
          $('.spare-parts').show();
        }
        break;
      default:
        break;
    }
  }
}

/* windows phone fix */

if (navigator.userAgent.match(/IEMobile\/10\.0/)) {
  const msViewportStyle = document.createElement('style');
  msViewportStyle.appendChild(document.createTextNode('@-ms-viewport{width:auto!important}'));
  document.getElementsByTagName('head')[0].appendChild(msViewportStyle);
}

// ajax images
function LoadAjaxImages() {
  const $ajaxImages = $('.ajaxProdImage');

  $ajaxImages.each(function () {
    const $this = $(this);

    const domain = getCurrentDomain(document.URL),
      nodeID = $this.data('nodeid'),
      cultureCode = $this.data('culturecode'),
      width = $this.data('imagewidth'),
      url = `http://${domain}/SiteFiles/Handlers/AgilityImage.ashx?NodeID=${nodeID}&CultureCode=${cultureCode}&Width=${width}`;

    // get url from handler
    $.ajax({
      url,
      context: this,
      success(response) {
        $(this).html(`<img class="loadedInImage" src="${response}" />`);
        $('.loadedInImage').load(() => {
          ImageLoaded();
        }).error(() => {
          ImageLoaded();
        });
        productsBox();
      },
    });
  });
}

// get current domain
function getCurrentDomain(data) {
  const a = document.createElement('a');
  a.href = data;
  return a.hostname;
}

// home page tabs
if ($('.picks').length > 0) {
  (function ($) {
    // add init to ajax end request handler
    Sys.WebForms.PageRequestManager.getInstance().add_endRequest(init);

    const $tabContainers = $('.picks'),
      $tabContents = $('.tab_content', $tabContainers);

    // initialise tabs
    function init() {
      loadProductImages();
    }

    // Also resize boxes on window resize
    $(window).resize(() => {
      $productItems.each(function () {
        $(this).height('auto');
      });
      SetProductBoxHeights();
      productsBox();
    });

    // load the content of each tab separately
    function loadProductImages() {
      $tabContainers.each(() => {
        $tabContents.each(loadTabContent);
      });
    }

    // load tab content
    function loadTabContent(tabIndex) {
      const $tabContent = $(this),
        $ajaxImages = $('.ajaxProdImage', $tabContent),
        toLoad = $ajaxImages.length;

      let loaded = 0;

      // set done to false
      $tabContent.data('done', false);

      // load images in tab
      $ajaxImages.each(function () {
        const $this = $(this);

        const domain = getCurrentDomain(document.URL),
          nodeID = $this.data('nodeid'),
          cultureCode = $this.data('culturecode'),
          width = $this.data('imagewidth'),
          url = `http://${domain}/SiteFiles/Handlers/AgilityImage.ashx?NodeID=${nodeID}&CultureCode=${cultureCode}&Width=${width}`;

        // get url from handler
        $.ajax({
          url,
          context: this,
          success(response) {
            $(this).html(`<img class="loadedInImage" src="${response}" />`);
            $('.loadedInImage').load(() => {
              ImageLoaded();
            }).error(() => {
              ImageLoaded();
            });

            loaded++;

            // all images have been initialised
            if ((loaded === toLoad) && (tabIndex === 0) && ($tabContent.data('done') === false)) {
              $tabContent.data('done', true);

              $tabContent.imagesLoaded().always(() => {
                $tabContainers.Tabs({
                  activate() {
                    SetProductBoxHeights();
                  },
                });
                // SetProductBoxHeights();
                productsBox();
              });
            }
          },
        });
      });
    }

    function SetProductBoxHeights() {
      const $list = $('.HomePage .productItem h3');
      if ($list.length) {
        layout.equaliseHeights($list);
      }
    }

    // get current domain
    function getCurrentDomain(data) {
      const a = document.createElement('a');
      a.href = data;
      return a.hostname;
    }

    // call initialise event
    init();
  }(jQuery));
}

$('.prodDetailsTabs').Tabs();

$(window).resize(() => {
  $('.review-form .file-upload>div>div>div').width($('.file-upload').outerWidth() - $('.file-upload .btn-browse').outerWidth() - 10);
});

$(window).load(() => {
  jQuery(document).ready(() => {
    const height = $(window).height();
    $('#brushlessframe').css('height', height);
  });
});
